import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const Wrapper = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 12;
  pointer-events: none;
  & > * {
    pointer-events: auto;
  }
`;

const pillChrome = css`
  background: ${({ theme: { colors = {} } }) => colors.surface ?? '#0E0F18'};
  border-radius: 16px;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.4);
  color: ${({ theme: { colors = {} } }) => colors.onSurface ?? '#E6E6F2'};
  animation: ${fadeIn} 220ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
`;

export const CollapsedButton = styled.button`
  ${pillChrome}
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 0;
  cursor: pointer;
  padding: 0;

  .material-symbols-rounded {
    font-size: 20px;
    opacity: 0.7;
  }

  &:hover {
    background: ${({ theme: { colors = {} } }) =>
      colors.surfaceContainerHigh ?? '#2A2A34'};
  }
`;

export const Panel = styled.div`
  ${pillChrome}
  padding: 10px 12px 12px;
  min-width: 148px;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const Title = styled.span`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  opacity: 0.6;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  color: inherit;
  opacity: 0.5;

  .material-symbols-rounded {
    font-size: 16px;
  }

  &:hover {
    opacity: 0.9;
    background: ${({ theme: { colors = {} } }) =>
      colors.surfaceContainerHigh ?? '#2A2A34'};
  }
`;

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Row = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Label = styled.span`
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
`;

export const Hint = styled.span`
  opacity: 0.5;
  font-weight: 400;
`;

export const MouseSvg = styled.svg`
  width: 20px;
  height: 26px;
  flex-shrink: 0;
  color: ${({ theme: { colors = {} } }) =>
    colors.onSurfaceVariant ?? '#A1A3B8'};
  --glyph-accent: ${({ theme: { colors = {} } }) =>
    colors.primaryFixedDim ?? '#C1C1FF'};
`;
